import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';

const StyledTitle = styled.div`
  width: ${scaleSize(1920)}px;
  color: #ffffff;
  font-size: ${scaleSize(72)}px;
  line-height: ${scaleSize(72)}px;
  font-family: 'RobotoBold', sans-serif;
  position: absolute;
  top: 0;
`;

export default ({ children, className }) => (
  <StyledTitle className={className}>{children}</StyledTitle>
);
